export default __webpack_public_path__ + "static/media/report_master-ioc.8ecc7c83.png";